import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import TaxRegimeList from "./TaxRegimeList";

export default {
  list: TaxRegimeList,
  icon: LocalAtmIcon,
};
